const carouselInjectionKey = Symbol("bvn::carousel");
const tabsInjectionKey = Symbol("bvn::tabs");
const progressInjectionKey = Symbol("bvn::progress");
const listGroupInjectionKey = Symbol("bvn::listGroup");
const avatarGroupInjectionKey = Symbol("bvn::avatarGroup");
const accordionInjectionKey = Symbol("bvn::accordion");
const checkboxGroupKey = Symbol("bvn::checkboxGroup");
const radioGroupKey = Symbol("bvn::radioGroup");
const collapseInjectionKey = Symbol("bvn::collapse");
const dropdownInjectionKey = Symbol("bvn::collapse");
const navbarInjectionKey = Symbol("bvn::navbar");
const rtlPluginKey = Symbol("bvn::rtlPlugin");
const breadcrumbPluginKey = Symbol("bvn::breadcrumbPlugin");
const modalManagerPluginKey = Symbol("bvn::modalManagerPlugin");
const defaultsKey = Symbol("bvn::defaults");
const inputGroupKey = Symbol("bvn::inputGroup");
const toastPluginKey = Symbol("bvn::toastPlugin");
const modalControllerPluginKey = Symbol("bvn::modalControllerPlugin");
const tooltipPluginKey = Symbol("bvn::toastPlugin");
const popoverPluginKey = Symbol("bvn::toastPlugin");
export {
  tooltipPluginKey as a,
  breadcrumbPluginKey as b,
  collapseInjectionKey as c,
  defaultsKey as d,
  dropdownInjectionKey as e,
  modalManagerPluginKey as f,
  accordionInjectionKey as g,
  avatarGroupInjectionKey as h,
  inputGroupKey as i,
  checkboxGroupKey as j,
  radioGroupKey as k,
  listGroupInjectionKey as l,
  modalControllerPluginKey as m,
  navbarInjectionKey as n,
  progressInjectionKey as o,
  popoverPluginKey as p,
  tabsInjectionKey as q,
  rtlPluginKey as r,
  carouselInjectionKey as s,
  toastPluginKey as t
};
//# sourceMappingURL=keys-CLEaYsGj.mjs.map
